<div class="wrapper">
  <!-- info boxes -->
  <div class="info-boxes" *ngIf="hasInfoBoxes">
    <ng-container *ngTemplateOutlet="infoBoxes"> </ng-container>
  </div>
  <div class="title-and-buttons">
    <div class="title-wrapper" [ngStyle]="{ 'text-decoration': article.archived && 'line-through' }">
      <div class="icon-or-checkbox">
        <ion-checkbox *ngIf="showCheckbox" [checked]="checked" (ionChange)="onCheckboxChange($event)" [disabled]="disabled"></ion-checkbox>
        <itl-alberta-icon *ngIf="showCheckbox === false" class="icon" [name]="icon"></itl-alberta-icon>
      </div>
      <div>
        <div class="title">
          {{ article.name }}
        </div>
        <div *ngIf="hasDosage" class="dosage"><ng-container *ngTemplateOutlet="dosage"> </ng-container></div>
      </div>
    </div>
    <!-- top action buttons -->
    <div class="action-buttons action-buttons-top" *ngIf="hasActions && isSmallScreen === false">
      <ng-container *ngTemplateOutlet="actions"> </ng-container>
    </div>
  </div>
  <div class="body">
    <!-- stars -->
    <ng-container *ngTemplateOutlet="stars"> </ng-container>

    <!-- labels -->
    <div class="labels" *ngIf="hasLabels">
      <ng-container *ngTemplateOutlet="labels"> </ng-container>
    </div>

    <!-- info cards -->
    <div class="cards">
      <!-- basic cards -->
      <div class="card-container">
        <itl-card [header]="'article.position' | translate" *ngIf="position"> {{ position }} </itl-card>
        <itl-card [header]="'device.articleDescription' | translate">
          {{ article?.description || 'k.A.' }}
        </itl-card>
        <itl-card [header]="'article.details.additionalDescription' | translate">
          {{ article?.additionalDescription || 'k.A.' }}
        </itl-card>
        <itl-card [header]="'order.edit.customerNumber' | translate">
          {{ article?.customerNumber || 'k.A.' }}
        </itl-card>
        <itl-card [header]="'directOrder.pcn' | translate"> {{ article?.pcn || 'k.A.' }} </itl-card>
        <itl-card [header]="'directOrder.manufacturerNumber' | translate">
          {{ article?.manufacturerNumber || 'k.A.' }}
        </itl-card>
        <ng-container *ngTemplateOutlet="cards"> </ng-container>
      </div>
      <!-- additional cards-->
      <div *ngIf="isExpanded" class="card-container">
        <itl-card *ngIf="article.manufacturer" [header]="'article.details.manufacturer' | translate">
          {{ article.manufacturer }}
        </itl-card>
        <itl-card
          *ngIf="article?.medicalAidPositionNumber"
          [header]="'order.edit.medicalAidPositionNumber' | translate"
        >
          {{ article?.medicalAidPositionNumber }}
        </itl-card>
        <itl-card *ngIf="article?.ean" [header]="'order.edit.ean' | translate"> {{ article?.ean }} </itl-card>
        <itl-card *ngIf="article?.size" [header]="'article.details.size' | translate">
          {{ article?.size }}
        </itl-card>
        <itl-card *ngIf="article?.inventoryType" [header]="'order.edit.articleType' | translate">
          {{ article?.inventoryType | articleInventoryTypePipe }}
        </itl-card>
        <ng-container *ngTemplateOutlet="additionalCards"> </ng-container>
      </div>
      <!-- show more chevron button -->
      <div class="show-more-wrapper">
        <itl-card class="show-more-button" *ngIf="showChevron" (click)="isExpanded = !isExpanded"
          ><itl-alberta-icon [name]="this.isExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"></itl-alberta-icon
        ></itl-card>
      </div>
    </div>
  </div>
</div>

<!-- bottom action buttons -->
<div class="action-buttons action-buttons-bottom" *ngIf="hasActions && isSmallScreen">
  <ng-container *ngTemplateOutlet="actions"> </ng-container>
</div>
